/**
 * Format an entity's location for compact display on cards.
 * Prefers structured city/state fields (added Feb 2026 for full-address entities);
 * falls back to extracting "City, ST" from a longer location string;
 * falls back to the raw location string for legacy entities (e.g. "Colorado").
 */
export function formatShortLocation(entity) {
  if (!entity) return '';
  const { city, state, location } = entity;

  if (city && state) return `${city}, ${state}`;
  if (city) return city;
  if (!location) return '';

  // Try to extract a "City, ST" tail from a comma-separated address.
  const parts = location
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length >= 2) {
    // Last part may be country (e.g. "United States") — try second-to-last + state
    const last = parts[parts.length - 1];
    const secondLast = parts[parts.length - 2];
    // If last looks like a 2-letter state or "ZIP" pattern, return "city, state"
    if (last.toUpperCase() === 'UNITED STATES' && parts.length >= 3) {
      return `${parts[parts.length - 3]}, ${secondLast}`;
    }
    return `${secondLast}, ${last}`;
  }

  return location;
}
